import Alpine from 'alpinejs';
import config from '@src/js/config';
import { getQueryParam } from '@src/js/utils/http';
Alpine.data("confirmSignup", () => ({
    confirmationKey: '',
    status: 'pending',
    error: {},
    async confirmRegistration() {
        // get the user id from the params store
        // get the user id from the url
        let userId = getQueryParam('userId');
        try {
            const response = await fetch(config.API_URL + "account/confirm", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    confirmationKey: this.confirmationKey,
                    userId
                }),
            });
            if (!response.ok) {
                const error = await response.json();
                console.log("im in error");
                console.log(error);
                this.error.message = error.message || 'An error occurred';
                this.status = 'error';
                this.confirmationKey = '';
                return;
            }
            this.status = 'confirmed';
        }
        catch (err) {
            console.log(err);
            this.error.message = 'Failed to connect to the server. Please try again later.';
        }
    },
    init() {
    }
}));
